import { Card } from '@/components/ui/card';
import { Send, Download, CheckCircle, AlertTriangle } from 'lucide-react';
import { useTranslation } from '@/i18n/i18n';

export const KSeFFeatures = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: Send,
      title: t('ksef.features.item1.title'),
      description: t('ksef.features.item1.desc'),
    },
    {
      icon: Download,
      title: t('ksef.features.item2.title'),
      description: t('ksef.features.item2.desc'),
    },
    {
      icon: CheckCircle,
      title: t('ksef.features.item3.title'),
      description: t('ksef.features.item3.desc'),
    },
    {
      icon: AlertTriangle,
      title: t('ksef.features.item4.title'),
      description: t('ksef.features.item4.desc'),
    },
  ];

  return (
    <section aria-labelledby="ksef-features-heading" className="py-16 px-6 md:px-8 bg-background">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2
            id="ksef-features-heading"
            className="text-3xl md:text-4xl lg:text-5xl font-semibold mb-6 tracking-tight"
          >
            {t('ksef.features.heading')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {features.map((feature) => {
            const Icon = feature.icon;
            return (
              <Card
                key={feature.title}
                className="group p-8 h-full transition-shadow duration-300 border border-border/50 hover:shadow-lg hover:border-primary/20"
              >
                <div className="mb-6">
                  <div className="size-14 rounded-2xl bg-primary/10 flex items-center justify-center">
                    <Icon className="size-7 text-primary" />
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-3">{feature.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {feature.description}
                </p>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
